import withQuery from "with-query";

const api = {
  getTemperature: (parameters, token) => {
    return get("/api/data/temperature", parameters, token);
  },
  addExtractionTask: (parameters, token) => {
    console.log(parameters);
    return post(
      "/api/data/run",
      {
        username: "arctic_user",
        email: "user@arcticrouter.com",
        ...parameters,
      },
      token
    );
  },
  getExtractionTasks: (parameters, token) => {
    return get("/api/data/list", parameters, token);
  },
  getPassageList: (parameters, token) => {
    return get("/api/data/user_passage_list", parameters, token);
  },
  plan: (parameters, token) => {
    return post("/plan/model/api/path_plan", parameters)
  },
  evaluate: (parameters, token) => {
    return get("/plan/model/api/computeamodel?date=20200506")
  }
};

export default api;

class ServerError {
  constructor(message, code) {
    this.msg = message;
    this.code = code;
  }
}

export const get = (endpoint, parameters, token = "unsafe") => {
  let url = withQuery(endpoint, parameters);
  return fetch(url, {
    method: "get",
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: token,
    }),
  })
    .then((response) => {
      switch (response.status) {
        case 500:
          throw new ServerError("服务器出错", 500);
        case 401:
          throw new ServerError("未登录", 401);
        case 405:
          throw new ServerError("服务器出错", 405);
        case 200: {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        }
        default:
          throw new ServerError("网络错误。", 500);
      }
    })
    .then((json) => {
      if (json.status === "ERROR") {
        return Promise.reject(json);
      }
      return json.msg;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const post = (endpoint, parameters, token = "unsafe") => {
  return fetch(endpoint, {
    method: "post",
    body: JSON.stringify(parameters),
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: token,
    }),
  })
    .then((response) => {
      console.log(response)
      switch (response.status) {
        case 500:
          throw new ServerError("服务器出错", 500);
        case 401:
          throw new ServerError("未登录", 401);
        case 405:
          throw new ServerError("服务器出错", 405);
        case 200: {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        }
        default:
          throw new ServerError("网络错误。", 500);
      }
    })
    .then((json) => {
      if (json.status === "ERROR") {
        return Promise.reject(json.msg);
      }
      return json.msg;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
